import Blob from "cross-blob";
import { Document, ISectionOptions, Packer, Paragraph } from "docx";
import flattenDeep from "lodash/flattenDeep";

import { ApplicationFull } from "@/lib/prisma";

import { docStyles } from "./common";
import { numberingStyle } from "./common/numbering";
import { DocGenerator } from "..";
import { renderProseMirrorSchemaToGoogleDoc } from "../proseMirror";

interface SelfServicePersStatemantDoc {
  application: ApplicationFull;
}

export const createSelfServicePersStatemantDoc: DocGenerator<
  SelfServicePersStatemantDoc
> = async (t, { application }) => {
  const document = new Document({
    styles: docStyles,
    numbering: numberingStyle,
    sections: [
      {
        children: flattenDeep<ISectionOptions["children"][0] | null>([
          [
            application.introduction,
            application.achievements,
            application.metrics,
            application.plans,
            application.conclusion,
          ].map((text) =>
            text
              ? [
                  renderProseMirrorSchemaToGoogleDoc(text, "-"),
                  new Paragraph({
                    style: "wellSpaced",
                  }),
                ]
              : null
          ),
        ]).filter((x): x is ISectionOptions["children"][0] => x !== null),
      },
    ],
  });

  return new Blob([await Packer.toBuffer(document)]);
};
